
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

@Component({
  computed: {
    ...mapGetters({
      getDarkMode: 'getDarkMode',
      getSavedFileContent: 'getSavedFileContent',
    }),
  },
  methods: {
    ...mapActions({
      fetchCfgFromServerByName: 'fetchCfgFromServerByName',
      setSnackBarText: 'setSnackBarText',
    }),
  },
})
export default class SaveLocalConfigDialog extends Vue {
  @Prop(Boolean) dialogVisible!: boolean
  @Watch('loader')
  // eslint-disable-next-line no-unused-vars
  onLoaderChange(val: any, oldVal: any) {
    console.log('VAL:' + val)
    console.log('OLDVAL: ' + oldVal)

    const l = this.loader
    this[l] = !this[l] //TODO: how this works??

    setTimeout(() => (this[l] = false), 3000) //TODO do this with real axios response

    this.loader = null
  }

  private getSavedFileContent!: any //maybe unecessary since we have map as variable

  private loader: any = null
  private loading3: boolean = false
  private dialogHeader: string = 'Save local config (to JSON file)'
  private dialogText: string = ''
  private dialogValue: string = 'File name'
  private enterText: boolean = false

  private setSnackBarText!: (payload: {
    snackBarText: string
    snackBarColor: string
  }) => Promise<any>

  public onSave() {
    if (this.dialogValue == 'File name' || this.dialogValue.length == 0) {
      this.setSnackBarText({
        snackBarText: 'Type configuration name first!',
        snackBarColor: 'red',
      })
      return false
    }

    this.uploadFile()

    this.$emit('update:dialogVisible', false)
  }

  public uploadFile() {
    this.loader = 'loading3'
    this.$store.dispatch('parseMapToJSONFile')

    const data = this.getSavedFileContent //TODO: reparse map back to JSON
    const blob = new Blob([data], { type: 'text/plain' })
    const e = document.createEvent('MouseEvents'),
      a = document.createElement('a')
    a.download = this.dialogValue + '.json'
    //a.download = 'test.json' //OVERRIDE FOR TEST

    a.href = window.URL.createObjectURL(blob)
    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
    e.initEvent('click', true, false)
    a.dispatchEvent(e)
  }

  public cancelClicked() {
    //console.log('CANCEL CLICKED')

    this.$emit('update:dialogVisible', false)
  }
}
